import money from '../../../assets/images/avartar/avatar-money@2x.png';
import bell from '../../../assets/images/avartar/avatar-bell@2x.png';
import calcurator from '../../../assets/images/avartar/avatar-calcurator@2x.png';
import mydata from '../../../assets/images/avartar/avatar-mydata@2x.png';
import credit from '../../../assets/images/avartar/avatar-credit@2x.png';

import {
  IN_APP_LANDING_TYPE,
  LANDING_TYPE,
  MEDIA_NAME,
  OS_TYPE,
} from '../../types/types';
import { ClkBtnSubEventNm, EventNm } from '../../hooks/useBeacon';

// ui
// link
// beacon

interface CardItem {
  avatar: {
    source: string;
    alt: string;
  };
  primaryText: string;
  secondaryText: string;
  exclude: string[];
  link: {
    landingType: LANDING_TYPE;
    landingDestinationCollection: {
      [index: string]: string;
    };
  };
  versionFilter?: {
    [index: string]: {
      [osType: string]: number;
    };
  };
  beacon: {
    eventNm: string;
    subEventNm: string;
  };
}

export const HOME_CARD_LIST: CardItem[] = [
  {
    avatar: {
      source: mydata,
      alt: '마이데이터',
    },
    primaryText: '마이데이터',
    secondaryText: '신용점수 조회',
    exclude: [MEDIA_NAME.SKT, MEDIA_NAME.LGU, MEDIA_NAME.KT],
    link: {
      landingType: LANDING_TYPE.in_app,
      landingDestinationCollection: {
        skt: '',
        kt: IN_APP_LANDING_TYPE.K_MD_CB,
        lgu: '',
      },
    },
    beacon: {
      eventNm: '',
      subEventNm: '',
    },
  },
  {
    avatar: {
      source: money,
      alt: '금융상품',
    },
    primaryText: '금융상품',
    secondaryText: '대출/카드/보험',
    exclude: [],
    link: {
      landingType: LANDING_TYPE.in_app,
      landingDestinationCollection: {
        skt: IN_APP_LANDING_TYPE.S_EB_HOME,
        kt: IN_APP_LANDING_TYPE.K_EB_HOME,
        lgu: IN_APP_LANDING_TYPE.L_EB_LOAN,
      },
    },
    beacon: {
      eventNm: EventNm.ClkBtn,
      subEventNm: ClkBtnSubEventNm.CardFinPrd,
    },
  },
  // {
  //   avatar: {
  //     source: bell,
  //     alt: '정기알림서비스',
  //   },
  //   primaryText: '정기알림서비스',
  //   secondaryText: '매월 자동 심사',
  //   exclude: [],
  //   link: {
  //     landingType: LANDING_TYPE.in_link,
  //     landingDestinationCollection: {
  //       skt: '/skt/notiPreReg',
  //       kt: '/kt/notiPreReg',
  //       lgu: '/lgu/notiPreReg',
  //     },
  //   },
  //   beacon: {
  //     eventNm: EventNm.ClkBtn,
  //     subEventNm: ClkBtnSubEventNm.CardNotiSchAlrt,
  //   },
  // },
  {
    avatar: {
      source: calcurator,
      alt: '이자 계산기',
    },
    primaryText: '이자 계산기',
    secondaryText: '상환 금액 계산',
    exclude: [],
    link: {
      landingType: LANDING_TYPE.in_link,
      landingDestinationCollection: {
        skt: '/skt/rateCalc',
        kt: '/kt/rateCalc',
        lgu: '/lgu/rateCalc',
      },
    },
    beacon: {
      eventNm: EventNm.ClkBtn,
      subEventNm: ClkBtnSubEventNm.CardInstrstCalc,
    },
  },
  {
    avatar: {
      source: credit,
      alt: '신용지키미',
    },
    primaryText: '신용지키미',
    secondaryText: '신용점수 관리하기',
    exclude: [MEDIA_NAME.SKT, MEDIA_NAME.LGU],
    link: {
      landingType: LANDING_TYPE.in_app,
      landingDestinationCollection: {
        skt: '',
        kt: IN_APP_LANDING_TYPE.K_MD_CREDIT,
        lgu: '',
      },
    },
    versionFilter: {
      kt: {
        IOS: 200010036,
        Android: 200010041,
      },
    },
    beacon: {
      eventNm: '',
      subEventNm: '',
    },
  },
];
